import './style.css';

import React, { Component } from 'react';

import Constants from '../../Phi/Constants';
import { Glyphicon } from 'react-bootstrap';
import PropTypes from 'prop-types';
import avatarBoy from '../../Assets/avatar-child-boy.png';
import avatarGirl from '../../Assets/avatar-child-girl.png';
import { cleanString } from './utils';
import moment from 'moment'

// import 'font-awesome/css/font-awesome.min.css';



export default class AlertDropdown extends Component {

    constructor(props) {
        super(props);

        this.options = Object.assign({}, props.options);
    }

    render() {
        return (
            this.props.alertList && this.props.alertList.length ? this.props.alertList.map((element, index) => (
                <div
                    className="hsg-header-dropdown-menu-option"
                    onClick={() => this.props.onClickAlert()}
                    key={index}
                >
                    <p>{cleanString(element.alert_custom_json.alert)}</p>
                    <p>{`Added on: ${moment(element.created_time).format(Constants.defaultDateFormat)}`}</p>
                </div>
            )) : <div className="hsg-header-dropdown-menu-option">
                    <p>No data available</p>
                </div>
        );
    }

}

AlertDropdown.propTypes = {
    alertList: PropTypes.array.isRequired,
    alertType: PropTypes.string.isRequired,
    onClickAlert: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/Components/AlertDropdown/index.js